module.exports = __webpack_public_path__ + "media/img/files/file-4-a2951419d096dff190589750389da50c.jpg";